import psl_events from './libs/psl_events.js';

let _events=new psl_events.class();

let _data={
	era:0,
	roads:true,
	cities:true,
	ama_members:true,
	covered_km:true,
};

const state={
	reinit:()=>{
		_data.era=0;
		_data.roads=true;
		_data.cities=true;
		_data.ama_members=true;
		_data.covered_km=true;
		_events.emit('reinit');
		_events.emit('era',_data.era);
		_events.emit('roads',_data.roads);
		_events.emit('cities',_data.cities);
		_events.emit('ama_members',_data.ama_members);
		_events.emit('covered_km',_data.covered_km);
	},
	events:_events,
	get era(){
		return _data.era;
	},
	set era(v = 0){
		if(_data.era === v) return;
		_data.era=v;
		_events.emit('era',_data.era);

		return _data.era;
	},
	get roads(){
		return _data.roads;
	},
	set roads(v = true){
		if(_data.roads === v) return;
		_data.roads=v;
		_events.emit('roads',_data.roads);
	},
	get cities(){
		return _data.cities;
	},
	set cities(v = true){
		if(_data.cities === v) return;
		_data.cities=v;
		_events.emit('cities',_data.cities);
	},
	get ama_members(){
		return _data.ama_members;
	},
	set ama_members(v = true){
		if(_data.ama_members === v) return;
		_data.ama_members=v;
		_events.emit('ama_members',_data.ama_members);
	},
	get covered_km(){
		return _data.covered_km;
	},
	set covered_km(v = true){
		if(_data.covered_km === v) return;
		_data.covered_km=v;
		_events.emit('covered_km',_data.covered_km);
	}
}

export default state;
